import { Pipe, PipeTransform } from '@angular/core';
import { ParticipantCountTypeEnum, SessionUserRole } from '../helpers/enums/enums';
import { getRoleIdFromParticipant, isArrayNotEmpty, isDisplayVideoTile } from '../helpers/utils';
import { Participant, ParticipantType } from '../interfaces/participant.interface';
import { LoggerService } from '../services/logger.service';


@Pipe({
    name: 'participantCount'
})
export class ParticipantCountPipe implements PipeTransform {

    constructor(private readonly logger: LoggerService) { }
    transform(participants: Participant[], currentParticipantId: string, action = ParticipantCountTypeEnum.nonWaiting): number {
        if (!isArrayNotEmpty(participants)) return;
        let pcount = 0;
        try {
            if (action === ParticipantCountTypeEnum.nonWaiting) {
                pcount = participants.filter(p => (isDisplayVideoTile(p) && !p.isMedia && (!p.isWaiting || p.id === currentParticipantId))).length;
                //console.log('non-waiting', pcount, participants)
            }
            else if (action === ParticipantCountTypeEnum.waiting) {
                pcount = participants.filter(p => {
                    if (p.id === currentParticipantId) {
                        return false;
                    }
                    if (p.isWaiting) {
                        return true;
                    }
                }).length
            }
            else if (action === ParticipantCountTypeEnum.audience) {
                pcount = participants.filter(p => {
                    const roleId = getRoleIdFromParticipant(p);
                    if (!p.isWaiting && roleId === SessionUserRole.audience) {
                        return p
                    }
                }).length;
            }
            else if (action === ParticipantCountTypeEnum.audienceLimit) {
                pcount = participants.filter(p => {
                    const roleId = getRoleIdFromParticipant(p);
                    if (roleId === SessionUserRole.audience) {
                        return p
                    }
                }).length;
            }
            return pcount;
        } catch (error) {
            this.logger.error('ParticipantCountPipe_error', error);
            return pcount;
        }
    }
}